module.exports = __webpack_public_path__ + "img/welcome-rise.05cd684a.svg";